import {Button, DataStatus} from 'platform/components';
import {Center, Show, VStack} from 'platform/foundation';

import {useRefreshTokenMutation} from '@dms/api/core';
import {useLazyGetDocument360RedirectUrlQuery} from '@dms/api/security';
import {browserStorageKey} from '@dms/config';
import i18n from '@dms/i18n';
import {buildUrl, doc360Routes, getWorkspaceFromUri, redirectToLogin} from '@dms/routes';
import {handleApiError} from '@dms/shared';

import {useOnMount} from 'shared/web';

export function Doc360Initialize() {
  const [handleRefreshToken] = useRefreshTokenMutation();
  const [getDocument360RedirectURl, {isError}] = useLazyGetDocument360RedirectUrlQuery();
  const {workspace} = getWorkspaceFromUri();

  const handleRedirectToLogin = () => {
    redirectToLogin({workspace, redirectUrl: buildUrl(doc360Routes.redirect, workspace, false)});
  };

  useOnMount(() => {
    const refreshToken = localStorage.getItem(browserStorageKey.REFRESH_TOKEN);
    if (!refreshToken) {
      handleRedirectToLogin();
      return;
    }

    handleRefreshToken({
      workspace: workspace!,
      refreshTokenRequestBody: {
        refreshToken,
      },
    })
      .unwrap()
      .then((response) => {
        if (response && response.refreshToken && response.token) {
          sessionStorage.setItem(browserStorageKey.ACCESS_TOKEN, response.token);
          localStorage.setItem(browserStorageKey.REFRESH_TOKEN, response.refreshToken);

          getDocument360RedirectURl({redirectTo: decodeURIComponent('/')})
            .unwrap()
            .then((res) => res.redirectUrl)
            .then((url) => window.open(url, '_self'));
        }
      })
      .catch((error: Error & {status?: number}) => {
        if (error.status === 401) {
          handleRedirectToLogin();
          return;
        }
        handleApiError(error, {silent: true});
      });
  });

  return (
    <Center height="100vh" width="100%">
      <VStack spacing={4}>
        <DataStatus isLoading isError={isError} />

        <Show when={isError}>
          <Button
            title={i18n.t('page.login.actions.backToLogin')}
            onClick={handleRedirectToLogin}
          />
        </Show>
      </VStack>
    </Center>
  );
}
